import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    gethotelcleaners, saveRooster, getIssuefromCleaningAssignment,updateIssue
} from "../dbconnector/connector";
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import EmployeeRoosterNode from '../customNodes/EmployeeRoosterNode';
import Button from 'react-bootstrap/Button';
import { CgCloseR } from "react-icons/cg";
import { json } from 'react-router-dom';
import { getfilesurl, downloadfile } from '../tools/filehandler';
import ImageViewer from './ImageViewer';

const IssueReportNode = ({ rights, t, assignmentDisabled, data, events }) => {

    const [issue, setIssues] = useState({})
    const [picturenameArray, setPicturenameArray] = useState([]);

    useEffect(() => {
        //console.log(data)
        setIssues([])
        if (data !== undefined && data.id !== undefined) {
            getIssuefromCleaningAssignment(data.id).then((result) => {
                if (result.status === 200) {
                    result.json().then((data) => {
                        setIssues(data);
                    })
                } else {
                    //setErrorMessage(result.statusText);
                }
            })
        }

    }, [data])

    useEffect(() => {
        if (issue.id) {
            getfilesurl(2, issue.id).then((urls) => {
                setPicturenameArray(urls);
            });
        }

    }, [issue])

    const onchange = (e) => {
        setIssues({ ...issue, [e.target.name]: e.target.value });
    }

    const handleCancel = (e) => {
        setPicturenameArray([]);
        setIssues({});
        events.handleCancel(e);

    }
    const handleIssue = (issue) => {
        delete issue.picture
        const response = updateIssue(issue.id, issue)
        events.handleIssue()
        response.then(res => {
            if (res.status === 200) {                
                if(document.getElementById("IssueResolvedchecked").checked){
                    events.handleCheck()
                    events.handleIssue()
                }
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    return (
        <>
            <div id="assignmentIssuedetails" className='assignmentdiv'>
                <div className='formcaption' onMouseDown={(e)=>events.startdrag("assignmentIssuedetails", true,e)} onMouseUp={(e)=>events.startdrag(null, false,e)}>{t('IssueReportTitle')} <CgCloseR className='closer' onClick={handleCancel} /></div>
                <div className="AssignCleaningform">
                    <label className='labelhotel'>
                        {t('Description')}
                    </label>
                    <textarea id="issuedescription" name="description" className="doublegrid" type='text' value={issue.description} onChange={onchange} disabled>
                    </textarea>
                    <label className='labelhotel'>
                    </label>
                    <ImageViewer imageArray={picturenameArray} data={data}  />
                    <label className='labelhotel'>
                        {t('Oplossing')}
                    </label>
                    <textarea id="issueresolution" name="resolution" value={issue.resolution} className="doublegrid" onChange={onchange} disabled={assignmentDisabled}>
                    </textarea>
                    <label className='labelhotel'>
                        {t('extratijd')}
                    </label>
                    <input id="extratime" name="extratime" className="doublegrid" type='number' onChange={onchange} disabled={assignmentDisabled}>
                    </input>
                    <label className='labelhotel'>
                        {t('Probleemopgelost')}
                    </label>
                    <input id="IssueResolvedchecked" name="IssueResolved" className="doublegrid QAcheckbox" valueon="1" valueoff="0" type='checkbox' >
                    </input>
                    <div id="saveDiv" className="two_Buttons doublegrid">
                        <Button type="button" id="saveButton" onClick={()=>handleIssue(issue)} className="Savebutton">{t('Save')}</Button>
                        <Button type="button" id="cancelButton" className="Savebutton" onClick={handleCancel} >{t('Cancel')}</Button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default IssueReportNode;
